export default function getContentElementClass(isCreateAccountActive) {
  return {
    content: isCreateAccountActive
      ? 'dtv-html5-c-pin-login-flow-create-account__content'
      : 'dtv-html5-c-pin-login__content',
    container: isCreateAccountActive
      ? 'dtv-html5-c-pin-login-flow-create-account__content-container'
      : 'dtv-html5-c-pin-login__content-container',
    title: isCreateAccountActive
      ? 'dtv-html5-c-pin-login-flow-create-account__content-title'
      : 'dtv-html5-c-pin-login__content-title',
    qrCodeDescription: isCreateAccountActive
      ? 'dtv-html5-c-pin-login-flow-create-account__content-description'
      : 'dtv-html5-c-pin-login__content-text--wrap-lines',
    qrCode: isCreateAccountActive
      ? 'dtv-html5-c-pin-login-flow-create-account__qr-code'
      : 'dtv-html5-c-pin-login__qr-code',
  };
}
